<template>
    <v-app>
        <v-navigation-drawer
                width="250"
                class="primary pb-0"
                dark
                persistent
                :mini-variant="miniVariant"
                v-model="drawer"
                fixed
                app
        >
            <v-toolbar flat class="transparent">
                <v-list :class="{'list-border-bottom' : miniVariant}">
                    <v-list-tile>
                        <v-list-tile-content v-if="!miniVariant">
                            <v-list-tile-title><b>{{$t('app_name')}}</b></v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                            <v-btn icon @click.stop="miniVariant = !miniVariant">
                                <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
                            </v-btn>
                        </v-list-tile-action>
                    </v-list-tile>
                </v-list>
            </v-toolbar>
            <v-divider></v-divider>

            <v-tooltip right open-delay='0' close-delay='0'  :disabled="!miniVariant">
                <v-toolbar flat class="transparent" dense slot="activator">
                    <v-list class="pa-0" :class="{'list-border-bottom' : miniVariant}">
                        <v-list-tile
                                to="/dashboard"
                                exact
                                active-class="primary--text grey lighten-3"
                        >
                            <v-list-tile-action>
                                <v-icon>dashboard</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>{{$t('dashboard')}}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-toolbar>
                <span>{{$t('dashboard')}}</span>
            </v-tooltip>
            <v-divider></v-divider>

            <v-tooltip right open-delay='0' close-delay='0'  :disabled="!miniVariant" v-if="user != null && user.role == 'Admin'">
                <v-toolbar flat class="transparent" dense slot="activator">
                    <v-list class="pa-0" :class="{'list-border-bottom' : miniVariant}">
                        <v-list-tile
                                to="/user"
                                exact active-class="primary--text grey lighten-3"
                        >
                            <v-list-tile-action>
                                <v-icon>person</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>{{$t('user')}}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-toolbar>
                <span>{{$t('user')}}</span>
            </v-tooltip>
            <v-divider v-if="user != null && user.role == 'Admin'"></v-divider>

            <v-tooltip right open-delay='0' close-delay='0'  :disabled="!miniVariant" v-if="user != null && (user.role == 'Admin' || user.role == 'Product Moderator' || user.role == 'Product Advertiser') ">
                <v-toolbar flat class="transparent" dense slot="activator">
                    <v-list class="pa-0" :class="{'list-border-bottom' : miniVariant}">
                        <v-list-tile
                                to="/news"
                                exact active-class="primary--text grey lighten-3"
                        >
                            <v-list-tile-action>
                                <v-icon>library_books</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>{{$t('news')}}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-toolbar>
                <span>{{$t('news')}}</span>
            </v-tooltip>
            <v-divider v-if="user != null && (user.role == 'Admin' || user.role == 'Product Moderator' || user.role == 'Product Advertiser') "></v-divider>

            <v-tooltip right open-delay='0' close-delay='0'  :disabled="!miniVariant" v-if="user != null && (user.role == 'Admin' || user.role == 'Analyst') ">
                <v-toolbar flat class="transparent" dense slot="activator">
                    <v-list class="pa-0" :class="{'list-border-bottom' : miniVariant}">
                        <v-list-tile
                                to="/report"
                                exact active-class="primary--text grey lighten-3"
                        >
                            <v-list-tile-action>
                                <v-icon>assessment</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>{{$t('report')}}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-toolbar>
                <span>{{$t('report')}}</span>
            </v-tooltip>
            <v-divider v-if="user != null && (user.role == 'Admin' || user.role == 'Analyst') "></v-divider>

            <v-list subheader :class="{'list-border-bottom' : miniVariant}" class="pb-0" v-if="user != null && (user.role == 'Admin' || user.role == 'Product Moderator' || user.role == 'Product Advertiser')">
                <v-subheader>{{$t('product_management').toUpperCase()}}</v-subheader>
                <template v-for="item in productItems" >
                    <v-tooltip right open-delay='0' close-delay='0'  :disabled="!miniVariant" :key="item.title">
                        <v-list-tile
                                :key="item.icon"
                                :to="item.link"
                                exact active-class="primary--text grey lighten-3"
                                slot="activator"
                        >
                            <v-list-tile-action>
                                <v-icon v-html="item.icon"></v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title v-text="$t(item.title)"></v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <span v-text="$t(item.title)"></span>
                    </v-tooltip>
                </template>
            </v-list>
            <v-divider v-if="user != null && user.role == 'Admin'"></v-divider>

            <v-list subheader v-if="user != null && (user.role == 'Admin' || user.role == 'Machine Moderator' || user.role == 'Machine Operator')">
                <v-subheader>{{$t('machine_management').toUpperCase()}}</v-subheader>
                <template v-for="item in machineItems">
                    <v-tooltip right open-delay='0' close-delay='0'  :disabled="!miniVariant" :key="item.title">
                        <v-list-tile
                                :key="item.icon"
                                :to="item.link"
                                exact active-class="primary--text grey lighten-3"
                                slot="activator"
                        >
                            <v-list-tile-action>
                                <v-icon v-html="item.icon"></v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title v-text="$t(item.title)"></v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <span v-text="$t(item.title)"></span>
                    </v-tooltip>
                </template>
            </v-list>

        </v-navigation-drawer>

        <v-toolbar
                app
                :color="path() == '/dashboard' ? 'primary' : 'primary'"
                
                dark
        >
            <v-toolbar-side-icon
                    @click.stop="drawer = !drawer"
                    class="hidden-lg-and-up"
            />
            <v-menu :nudge-width="100" >
                <v-toolbar-title slot="activator" class="pl-2">
                    <span>{{ locales[locale] }}</span>
                    <!-- <v-icon>language</v-icon> -->
                </v-toolbar-title>
                <v-list>
                    <v-list-tile v-for="(value, key) in locales" :key="key" @click.prevent="setLocale(key)" :class="{'primary white--text' : key == locale}">
                        <v-list-tile-title v-text="value"></v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
            <v-spacer></v-spacer>

            <v-btn icon @click.stop="rightDrawer = !rightDrawer">
                <v-tooltip bottom>
                    <v-badge color="red" overlap slot="activator" style="margin-top:6px">
                        <span slot="badge" v-if="notification > 0">{{notification}}</span>
                        <v-icon>notifications</v-icon>
                    </v-badge>
                    <span>{{notification == 0 ? 'no notification' : notification > 1 ? notification+' notifications' : notification+' notification'}}</span>
                </v-tooltip>
            </v-btn>

            <v-menu
                    bottom
                    left
            >
                <v-btn icon slot="activator">
                    <v-avatar class="white" size="32">
                        <v-icon color="primary">person</v-icon>
                    </v-avatar>
                </v-btn>
                <v-list class="pa-0" v-if="user != null">
                    <v-list-tile >
                        
                        <v-list-tile-content>
                            <v-list-tile-title>{{user.name}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{user.role.toUpperCase()}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile key="profile" @click.stop="profileDialog = true">
                        <v-list-tile-action>
                            <v-icon>person</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>{{$t('your_info')}}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile key="lock_open" @click.prevent="logout">
                        <v-list-tile-action>
                            <v-icon>lock_open</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title >{{$t('logout')}}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-toolbar>

        <v-content class="grey lighten-3">
            <router-view />
        </v-content>

        <v-navigation-drawer
            temporary
            :right="right"
            v-model="rightDrawer"
            fixed
            app
        >
            <v-toolbar flat prominent dark class="primary">
                <v-toolbar-title>{{$t('notification')}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.stop="rightDrawer = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-list subheader dense>
                <v-subheader v-if="notification == 0">There is no notification.</v-subheader>
                <v-subheader v-if="product.length > 0">Product notification</v-subheader>
                <v-list-tile v-for="item in product" :key="item.category + ' - ' + item.primary_name">
                    <v-list-tile-content>
                        <div>{{ item.category + ' - ' + item.primary_name + ' is out of stock.' }}</div>
                    </v-list-tile-content>
                </v-list-tile>
                
                <v-subheader v-if="machine.length > 0">Machine notification</v-subheader>
                <v-list-tile v-for="item in machine" :key="item.id">
                    <v-list-tile-content>
                        <div v-if="item.location != ''">{{ item.name + ' at ' + item.location + item.text + '.' }}</div>
                        <div v-else>{{ item.name + item.text + '.' }}</div>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>


        <v-dialog v-model="profileDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{$t('your_info')}}</span>
                </v-card-title>
                <v-card-text>
                    <form>
                    <v-container grid-list-md v-if="item != null">
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field 
                                    v-model="item.email" 
                                    counter="100" 
                                    :label="$t('email')"
                                    disabled
                                    prepend-icon="email"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field 
                                    v-model="item.name" 
                                    counter="100" 
                                    :label="$t('name')"
                                    :error-messages="veeErrors.collect('name')"
                                    v-validate="'required|max:100'"
                                    data-vv-name="name"
                                    :data-vv-as="$t('name')"
                                    @keyup.enter="save" :disabled="inProgress"
                                    prepend-icon="face"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field 
                                    :label="$t('password')" 
                                    counter="50" 
                                    v-model="item.password"
                                    :error-messages="veeErrors.collect('password')"
                                    v-validate="'strong_password|max:50'"
                                    data-vv-name="password"
                                    :data-vv-as="$t('password')"
                                    type="password" 
                                    @keyup.enter="save" :disabled="inProgress"
                                    prepend-icon="lock_outline"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field 
                                    v-model="item.phone"
                                    counter="10"
                                    :label="$t('phone_number')" 
                                    :error-messages="veeErrors.collect('phone')"
                                    v-validate="'required|min:9|max:10'"
                                    data-vv-name="phone"
                                    :data-vv-as="$t('phone_number')"
                                    @keyup.enter="save" :disabled="inProgress" mask="phone"
                                    prepend-icon="smartphone"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    </form>
                    <small>Keep Password blank if you don't want to change</small>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click.native="profileDialog = false">{{$t('cancel')}}</v-btn>
                    <v-btn color="primary" @click.native="save">{{$t('save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import { loadMessages } from '~/plugins/i18n'
import axios from 'axios';
import swal from 'sweetalert2';

export default {
    name: "AppLayout",
    computed: mapGetters({
        user: "auth/user",
        locale: "lang/locale",
        locales: "lang/locales"
    }),
    data() {
        return {
            appName: window.config.appName,
            profileDialog: false,
            drawer: false,
            fixed: false,
            productItems: [
                {
                    icon: "local_offer",
                    title: "category",
                    link: "/category"
                },
                {
                    icon: "shopping_basket",
                    title: "product",
                    link: "/product"
                }
            ],
            machineItems: [
                {
                    icon: "kitchen",
                    title: "machine",
                    link: "/machine"
                },
                {
                    icon: "power",
                    title: "machine_transaction",
                    link: "/transaction"
                }
            ],
            miniVariant: false,
            right: true,
            rightDrawer: false,
            tabs: null,
            item: {},
            inProgress: false,
            machine: [],
            product: [],
            notification: 0
        };
    },

    methods: {
        async logout() {
            // Log out the user.
            await this.$store.dispatch("auth/logout");

            // Redirect to login.
            this.$router.push({ name: "login" });
        },
        setLocale (locale) {
            if (this.$i18n.locale !== locale) {
                loadMessages(locale)

                this.$store.dispatch('lang/setLocale', { locale })
            }
        },
        save() {
            let vm = this
            vm.inProgress = true;
            vm.$validator.validateAll()
			vm.$nextTick(function () {
				if(vm.veeErrors.any()){
                    vm.inProgress = false;
					swal({
						type: 'warning',
						title: vm.$t('profile'),
						text: 'The given data was invalid.'
					}).catch(swal.noop)
                    return;
				}

                axios.post('/api/user/update_profile',vm.item).then(function(response) {
                    vm.inProgress = false;
                    vm.profileDialog = false;
                    if(response.status == 200){
                        swal({
                            type: 'success',
                            title: vm.$t("profile"),
                            text: response.data.message
                        }).catch(swal.noop)
                        vm.item.password = null;
                        vm.$store.dispatch('auth/updateUser', { user: vm.item })
                    }else{
                        swal({
                            type: 'error',
                            title: vm.$t("profile"),
                            text: 'Something is wrong! Please try again.'
                        }).catch(swal.noop)
                    }
                }).catch(function (error) {
                    vm.inProgress = false;
                    //vm.dialog = false
                    let obj = error.response.data.errors;
                    for (const key in obj) {
                        if (obj.hasOwnProperty(key)) {
                            const element = obj[key];
                            vm.veeErrors.add(key, element, key);
                        }
                    }
                    swal({
                        type: 'error',
                        title: vm.$t("profile"),
                        text: error.response.data.message
                    }).catch(swal.noop)
                })
            })
        },
        path(){
            return this.$route.path;
        },
        getNotification () {
			let vm = this
			axios.post('/api/notification/get').then(function(response) {
				if(response.status == 200){
                    let machineArray = [];
                    response.data.machine.forEach(function(obj) {
                        if(obj.text != ''){
                            machineArray.push(obj)
                        }
                    })

                    vm.product = response.data.product
                    vm.machine = machineArray
                    vm.notification = parseInt(vm.product.length) + parseInt(vm.machine.length)
				}else{
					swal({
						type: 'error',
						title: vm.$t("notification"),
						text: 'Something is wrong! Please try again.'
					}).catch(swal.noop)
				}
			}).catch(function (error) {
                console.log(error)
                swal({
                    type: 'error',
                    title: vm.$t("notification"),
                    text: error.response.data.message
                }).catch(swal.noop)
			})
        },
    },
    components: {},
    created(){
        setTimeout(() => {
            this.getNotification();    
        }, 3000);
    },
    mounted: function() {
        this.item = JSON.parse(JSON.stringify(this.user));
        if (window.innerWidth >= 1264) {
            this.drawer = true;
        }
        window.onresize = function(event) {
            if (window.innerWidth < 1264) {
                this.drawer = false;
            }
        };
  }
};
</script>
<style >

html:lang(en) .swal2-container,
html:lang(en) .application,
html:lang(en) .headline{
    font-family: Quicksand,Nokora !important;
}

html:lang(km) .swal2-container,
html:lang(km) .application,
html:lang(km) .headline{
    font-family: Nokora,Quicksand  !important;
    line-height: 1.8  !important;
}

.bottom-menu {
  position: absolute;
  width: 100%;
  bottom: 0;
}

.searching {
  overflow: hidden;
  width: 100%;
  transform: 0.5s cubic-bezier(.25,.8,.50,1);
}

.searching--closed {
  width: 0;
}

.searching--closed > * {
  display: none;
}

.list-border-bottom {
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

li.subheader{color: inherit !important;}

.list__tile__title {
    height: 30px;
    line-height: 30px;
}

.forPrint{display: none !important;}

@media print {
    .v-navigation-drawer,
    .v-toolbar,
    .v-tabs__bar,
    .v-menu,
    .v-input-group,
    .v-btn,
    .v-tooltip__content,
    .v-datatable__actions__select,
    .v-text-field,
    .notForPrint{
        display: none;
    }

    .forPrint{display: block!important}

    .v-tabs__content,
    .v-content--wrap > .v-container.fluid{
        padding: 0 !important;
    }

    .v-card{
        box-shadow: none;
        border-width: 0px;
        border-radius: 0px;
    }

    .container{padding:0 !important;}

    main.v-content.grey.lighten-3{
        padding: 0 !important;
        background-color: #FFFFFF !important;
    }

    table.v-table thead td:not(:nth-child(1)),
    table.v-table tbody td:not(:nth-child(1)), 
    table.v-table thead th:not(:nth-child(1)), 
    table.v-table tbody th:not(:nth-child(1)), 
    table.v-table thead td:first-child, 
    table.v-table tbody td:first-child, 
    table.v-table thead th:first-child, 
    table.v-table tbody th:first-child{
        padding: 0 4px;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/layouts/app.vue